import axios from "axios";
import store from "../store";
import type from "../store/actions/types";

import { ResponseAPI } from "../models/interfaces";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use(
  function (config) {
    const token = store.getState().Authorization.token;
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  function (response) {
    const res: ResponseAPI = response.data;
    if (res.token != null) {
      localStorage.setItem("token", res.token);
      store.dispatch({
        type: type.SET_TOKEN,
        payload: res.token,
      });
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default api;
